export const ROUTE_INDEX = '/';
export const ROUTE_HOW_TO_INSTALL = '/how-to-install';
export const ROUTE_PRIVACY_POLICY = '/privacy-policy';
export const ROUTE_TERMS_OF_USE = '/terms-of-use';
